import { get as getAppState, set as setAppState } from '@hotjar/webapp/domains/common/app-state';

type UserId = number;

const APP_STATE_NAMESPACE = 'surveys';
const SKIPPED_INSTALLATION_KEY = 'skipped_installation';

interface UserSettingsCache {
  [key: number]: { [key: string]: string } | undefined;
}

const cache: UserSettingsCache = {};

function invalidateCache(siteId: number) {
  delete cache[siteId];
}

async function getSurveyUserSettings(userId: UserId, siteId: number) {
  if (!cache[siteId]) {
    cache[siteId] = await getAppState(userId, { siteId }).then(
      (state) => state[APP_STATE_NAMESPACE] || {},
    );
  }

  return cache[siteId];
}

export function checkSkippedInstallation(userId: UserId, siteId: number): Promise<boolean> {
  return getSurveyUserSettings(userId, siteId).then((state) =>
    state ? state[SKIPPED_INSTALLATION_KEY] !== undefined : false,
  );
}

export function skipInstallation(userId: UserId, siteId: number): void {
  invalidateCache(siteId);
  setAppState(
    userId,
    { namespace: APP_STATE_NAMESPACE, key: SKIPPED_INSTALLATION_KEY, value: 'true' },
    { siteId },
  );
}
